import {
  ManagementAppProxyRequestSchema,
  getManagementAppRouteDefinition,
  type ManagementAppProxyQuery,
  type ManagementAppRouteLabel,
  type ManagementAppRouteRequestPayload,
  type ManagementAppRouteResponsePayload,
  type JsonValue,
} from '@trinity/custom-page-proxy-routes';

type PostResponse<TData> = {
  data: TData;
};

type AuthenticatedHttpClient = {
  post: <TData>(
    url: string,
    data?: { route: ManagementAppRouteLabel; payload: JsonValue; query?: ManagementAppProxyQuery }
  ) => Promise<PostResponse<TData>>;
};

export class ChatAPIProxyClient<
  TAuthenticatedClient extends AuthenticatedHttpClient = AuthenticatedHttpClient,
> {
  constructor(private authenticatedClient: TAuthenticatedClient) {}

  async invokeManagementAppRoute<TLabel extends ManagementAppRouteLabel>(
    routeLabel: TLabel,
    payload: ManagementAppRouteRequestPayload<TLabel>,
    query?: ManagementAppProxyQuery
  ): Promise<ManagementAppRouteResponsePayload<TLabel>> {
    const route = getManagementAppRouteDefinition(routeLabel);
    route.requestSchema.parse(payload);

    const requestBody = ManagementAppProxyRequestSchema.parse({
      route: routeLabel,
      payload,
      query,
    });

    const response = await this.authenticatedClient.post<JsonValue>(
      '/proxy/custom-pages/management-app',
      requestBody
    );

    return route.responseSchema.parse(response.data);
  }
}
